



































































































import { AxiosInstance } from 'axios'
import { PasswordRepeat } from '@/components/registration/module/types'
import { isError } from 'lodash'

export default {
  mounted() {
    this.token = this.$route.query.token
  },
  data(): {
    password: string
    password_repeat: string
    token: string
    isSubmitted: boolean
    isError: boolean
    errorMessages: PasswordRepeat
  } {
    return {
      token: '',
      password: '',
      password_repeat: '',
      isError: false,
      isSubmitted: false,
      errorMessages: {
        password: [],
        password_confirmation: [],
      },
    }
  },
  methods: {
    finishPasswordReset() {
      const http: AxiosInstance = this.$store.getters.http

      http
        .post('/api/auth/users/finish_reset_password', {
          token: this.token,
          password: this.password,
          password_repeat: this.password_repeat,
        })
        .then(response => {
          const data = response.data
          if (!data.ok) {
            this.isSubmitted = false
            this.errorMessages = data.errors
          } else {
            this.isSubmitted = true
          }
        })
        .catch(e => {
          this.isError = true
        })
    },
  },
  computed: {
    passwordMessages() {
      if (this.errorMessages == null || !('password' in this.errorMessages)) {
        return []
      } else {
        return this.errorMessages.password
      }
    },
    passwordConfirmMessages() {
      if (this.errorMessages == null || !('password_confirmation' in this.errorMessages)) {
        return []
      } else {
        return this.errorMessages.password_confirmation
      }
    },
  },
}
